export default __webpack_public_path__ + "static/media/4.ea6ed0bb.png";